import { mapIdSchema } from "@dailywars/core/engine/types/inputSchemas";
import { notFound } from "@tanstack/react-router";
import * as z from "zod";

import { DOCUMENT_TITLES, documentHead } from "#/lib/documentTitle";

export const replayIdSchema = z.uuid();

export type MapIdRouteParams = { mapId: string };
export type ReplayIdRouteParams = { replayId: string };

function parseMapIdOrNotFound(mapId: string): string {
  const result = mapIdSchema.safeParse(mapId);
  if (!result.success) {
    throw notFound();
  }
  return result.data;
}

function parseReplayIdOrNotFound(replayId: string): string {
  const result = replayIdSchema.safeParse(replayId);
  if (!result.success) {
    throw notFound();
  }
  return result.data;
}

export const mapIdRouteParams = {
  parse: (params: MapIdRouteParams): MapIdRouteParams => ({
    mapId: parseMapIdOrNotFound(params.mapId),
  }),
  stringify: ({ mapId }: MapIdRouteParams) => ({ mapId }),
};

export const replayIdRouteParams = {
  parse: (params: ReplayIdRouteParams): ReplayIdRouteParams => ({
    replayId: parseReplayIdOrNotFound(params.replayId),
  }),
  stringify: ({ replayId }: ReplayIdRouteParams) => ({ replayId }),
};

export function mapIdRouteHead({
  mapId,
  titleForMapId,
  descriptionForMapId,
  pathForMapId,
  imageUrlForMapId,
}: {
  mapId: string;
  titleForMapId: (validMapId: string) => string;
  descriptionForMapId: (validMapId: string) => string;
  pathForMapId: (validMapId: string) => string;
  imageUrlForMapId?: (validMapId: string) => string;
}) {
  const result = mapIdSchema.safeParse(mapId);
  if (!result.success) {
    return documentHead(DOCUMENT_TITLES.home);
  }

  const validMapId = result.data;
  return documentHead(titleForMapId(validMapId), {
    description: descriptionForMapId(validMapId),
    canonicalPath: pathForMapId(validMapId),
    imageUrl: imageUrlForMapId?.(validMapId),
  });
}
